export const DropdownLinks = {
    appointmentHistory: '/patient/pastappointments',
    upcomingAppointments: '/patient/upcomingappointments',
    insurance: '/patient/insurancecardmanagement',
    medicalTeam: '/patient/medicalteam',
    providerCalendar: '/provider',
    providerAccount: '/provider/settings',
    providerHelp: '/provider/help',
    pulse: '/csr/default.aspx',
    settings: '/patient/editprofile',
    signout: '/signout',
    myDoctors: '/patient/doctors',
    myWellGuide: '/mywellguide',
    patientSignin: '/signin',
    providerSignin: '/signin?provider=1',
    subPatients: '/patient/subpatients',
};

export const DesktopPatientLoginAndSignupLink = {
    key: 'Patients',
    url: DropdownLinks.patientSignin,
    message: 'Log in / Sign up',
    dataTest: 'patient-login',
    metrics: {
        element: 'PatientLoginLink',
        action: 'Click header signin dropdown patient login link',
    },
};

export const DesktopPatientLoginLink = {
    message: 'Log in',
    dataTest: 'patient-login-link',
    metrics: {
        element: 'PatientLoginLink',
        action: 'Click header signin dropdown patient login',
    },
};

export const DesktopPatientSignupLink = {
    message: 'Sign up',
    dataTest: 'patient-signup-link',
    metrics: {
        element: 'PatientSignupLink',
        action: 'Click header signin dropdown patient signup',
    },
};

export const DesktopProviderLoginLink = {
    key: 'Doctors',
    url: DropdownLinks.providerSignin,
    message: 'Log in',
    dataTest: 'doctor-login',
    metrics: {
        element: 'ProviderLoginLink',
        action: 'Click header signin dropdown provider login link',
    },
};

export const MyAccountLinksConversionIds = {
    patient: 'HeaderLoginPatientClicked',
    provider: 'HeaderLoginProviderClicked',
};
